import { Typography } from '@mui/material';
import React from 'react';

// Define an interface for the props
interface HomeSmallHeaderProps {
	text: string;
}

const HomeSmallHeader: React.FC<HomeSmallHeaderProps> = ({ text }) => (
	<Typography
		color="primary"
		variant="body1"
		fontWeight={700}
		align="center"
		gutterBottom
		height={'1.5rem'}
	>
		<Typography
			variant="overline"
			// fontSize={'23.25px'}
			sx={{ marginTop: 'auto', marginBottom: 'auto', fontWeight: 800 }}
		>
			-
		</Typography>{' '}
		{text}
		{''}
		<Typography
			variant="overline"
			// fontSize={'23.25px'}
			sx={{ marginTop: 'auto', marginBottom: 'auto', fontWeight: 800 }}
		>
			-
		</Typography>
	</Typography>
);
// };

export default HomeSmallHeader;
